import { gql } from '@apollo/client'
import { query } from '@/service/apollo/client'

const getUserProducts = (userId, offset = 0, limit = 10) => query(
  gql`
    query {
      userProducts(
        where: {
          users_permissions_user: "${userId}",
          isDeleted: false,
          isSoldOut: false
        },
        start: ${offset},
        limit: ${limit}
      )
      {
          id
          name
          model
          images {
            url
          }
          users_permissions_user {
            id
          }
          brand {
            brandName
          }
          isSoldOut
          createdAt
          price
        }  
    }
  `
)

const countUserProducts = (userId) => query(
  gql`
    query {
      userProductsCount(where: {
        users_permissions_user: "${userId}"
      })
    }
  `
)

export {
  getUserProducts,
  countUserProducts
}
